export const unFormatterPhone = phone => phone.replace(/[^\d]/g, '');
